import React from "react";
import { I18nRichText } from "../inputs/I18nRichText";

type Props = {
  label: string;
  labelKey?: string;
  fullWidth: boolean;
  name: string;
  value?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const BooleanInput: React.FC<Props> = ({ label, labelKey, name, value, checked, onChange, fullWidth }) => {
  const id = value ? `${name}-${value}` : name;

  return (
    <div className={`form-check boolean-input form-check--choice ${fullWidth? 'form-check-full': ''}`}>
      <input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        className="form-check-input"
        aria-checked={checked}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-check-label" htmlFor={id}>
        <I18nRichText tKey={labelKey} fallbackText={label} />
      </label>
    </div>
  );
};

export default BooleanInput;
